export default {"src":"/_next/static/media/hearts.49cea23a.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};